import { TimePicker } from 'antd'
import React from 'react'

function TimeRange() {
  return (
    <TimePicker.RangePicker className='auf-time-picker' />
  )
}

export default TimeRange